import Vue from 'vue';

export function mountVuePortalTarget(el: HTMLElement, portalName: string): void {
    new Vue({
        render: (h) => h('portal-target', { props: { name: portalName } }),
    }).$mount(el);
}
